import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcprunrequest0getGetRunRequestsResponseSchema = jsonObject
export type tcprunrequest0getGetRunRequestsResponse = z.infer<typeof tcprunrequest0getGetRunRequestsResponseSchema>
